import { IsEqualCustomizer, isEqualWith, PropertyName } from "lodash";

const isSimilarObject = (previous: any, current: any, excludeKeys = ["_id"]): boolean => {
	const compareFn: IsEqualCustomizer = (_value1: any, _value2: any, indexOrKey: PropertyName | undefined) =>
		excludeKeys?.includes(String(indexOrKey)) ? true : undefined;
	return isEqualWith(previous, current, compareFn);
};

export { isSimilarObject };
